import { render, staticRenderFns } from "./ExternalInvoices.vue?vue&type=template&id=70e49726"
import script from "./ExternalInvoices.vue?vue&type=script&lang=js"
export * from "./ExternalInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports